import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import InfiniteScroll from 'react-infinite-scroller';
import { CheckboxStyled } from '@nike/nike-design-system-components';

import Spinner from '../spinner/Spinner';

const TableInfiniteScroll = ({
  data,
  columns,
  handleClick,
  selectedId,
  clickTarget,
  className,
  bodyClassName,
  overrideClass,
  cellProps,
  headerProps,
  loadMore,
  hasMore,
  keyTarget,
  includeRowSelect,
  rowSelectAction,
  selectedIdMap
}) => {
  const renderData = (column, idx, data, props) => (
    <td
      key={column.id}
      className='prl3-sm pt5-sm pb5-sm u-capitalize'
      data-desc={`table__row${idx}_${column.id}`}
      style={column.id === 'purchaseOrderRef' ? { overflowWrap: 'break-word' } : {}}
    >
      {/* eslint-disable-next-line no-nested-ternary */}
      {column && column.cell
        ? column.cell(data, props)
        : data[column.id]?.toString().toLowerCase() === 'na'
        ? data[column.id]?.toString()
        : data[column.id]?.toString().toLowerCase()}{' '}
    </td>
  );

  const list = data.map((d, idx) => (
    <tr
      key={`tableRow__${d[keyTarget] || d.id}`}
      className={classnames('table__body-row body-3', {
        highlighted: selectedId && selectedId === d[clickTarget]
      })}
      onClick={handleClick ? e => handleClick(d[clickTarget] || d, e) : null}
    >
      {includeRowSelect && (
        <td style={{ alignContent: 'center', width: '50px' }} onClick={e => e.stopPropagation()}>
          <CheckboxStyled
            id={`${d.id}-checkbox`}
            checked={selectedIdMap[d.id]}
            onChange={e => rowSelectAction(d.id, e.target.checked)}
          />
        </td>
      )}
      {columns.map(column => renderData(column, idx, d, cellProps))}
    </tr>
  ));

  return (
    <div className={classnames(overrideClass || 'table__wrapper', className)}>
      <table>
        <thead className='table__header ta-sm-l body-4'>
          <tr className='table__header-row'>
            {includeRowSelect && <td className='table__header-th p3-sm' style={{ width: '50px' }} />}
            {columns.map(column => (
              <th key={column.id} className='table__header-th p3-sm'>
                {typeof column.header === 'function' ? column.header(data, headerProps) : column.header}
              </th>
            ))}
          </tr>
        </thead>
        <InfiniteScroll
          element='tbody'
          className={classnames('table__body body-3', bodyClassName)}
          pageStart={0}
          loadMore={loadMore}
          hasMore={hasMore}
          loader={
            <tr key={0} className='table__body-row ta-sm-c'>
              <td colSpan='9' style={{ height: '40px', position: 'relative' }}>
                <Spinner />
              </td>
            </tr>
          }
          initialLoad
          threshold={100}
        >
          {list}
        </InfiniteScroll>
      </table>
    </div>
  );
};

TableInfiniteScroll.defaultProps = {
  bodyClassName: null,
  cellProps: null,
  className: null,
  clickTarget: 'id',
  handleClick: null,
  overrideClass: null,
  selectedId: null,
  headerProps: null,
  keyTarget: 'id',
  includeRowSelect: false,
  rowSelectAction: null,
  selectedIdMap: {}
};

TableInfiniteScroll.propTypes = {
  bodyClassName: PropTypes.string,
  cellProps: PropTypes.any,
  className: PropTypes.string,
  clickTarget: PropTypes.string,
  columns: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired,
  handleClick: PropTypes.func,
  overrideClass: PropTypes.string,
  selectedId: PropTypes.string,
  hasMore: PropTypes.bool.isRequired,
  loadMore: PropTypes.func.isRequired,
  headerProps: PropTypes.object,
  keyTarget: PropTypes.string,
  includeRowSelect: PropTypes.bool,
  rowSelectAction: PropTypes.func,
  selectedIdMap: PropTypes.object
};

export default TableInfiniteScroll;
